module.exports = __webpack_public_path__ + "img/refund-success.c5601b91.svg";